import { createActions, createReducer } from "reduxsauce";
import { isConcierge, Roles } from "utils/functions";
import { defaultState } from "./user-session-model";

export const userSessionShowLoading = (state) => ({
  ...state,
  isLoading: true,
});

export const userSessionHideLoading = (state) => ({
  ...state,
  isLoading: false,
});

export const disabledRegisterButton = (state = defaultState) => ({
  ...state,
  disabledRegisterButton: true,
});

export const enableRegisterButton = (state = defaultState) => ({
  ...state,
  disabledRegisterButton: false,
});

export const userSessionLogout = () => ({
  ...defaultState,
});

export const updateSessionUser = (state, action: any) => {
  return {
    ...state,
    userData: action.userData,
    isAdmin: action.userData.role === Roles.ADMIN,
  };
};

export const setConciergePermission = (state, action: any) => ({
  ...state,
  isConcierge: isConcierge(action.isConcierge),
});

export const userSessionCollapseSidebar = (state) => ({
  ...state,
  isCollapseSidebar: true,
});

export const userSessionUncollapseSidebar = (state) => ({
  ...state,
  isCollapseSidebar: false,
});

export const locationsList = (state, { locationsList }) => ({
  ...state,
  locationsList,
});

export const updateMenuItemActive = (state, { menuItemActive }) => ({
  ...state,
  menuItemActive,
});

export const { Types, Creators } = createActions({
  userSessionShowLoading: [],
  userSessionHideLoading: [],
  userSessionEnabledRegisterButton: [],
  userSessionDisabledRegisterButton: [],
  userSessionLogout: [],
  userSessionUpdateUserData: ["userData"],
  userSessionSetConciergePermission: ["isConcierge"],
  userSessionCollapseSidebar: [],
  userSessionUncollapseSidebar: [],
  userSessionMenuItemActive: ["menuItemActive"],
  userSessionLocationsAsync: ["body"],
  userSessionLocationsList: ["locationsList"],
  userSessionUpdateLocationAsync: ["location"],
});

// map reducer to action
export default createReducer(defaultState, {
  [Types.USER_SESSION_SHOW_LOADING]: userSessionShowLoading,
  [Types.USER_SESSION_HIDE_LOADING]: userSessionHideLoading,
  [Types.USER_SESSION_DISABLED_REGISTER_BUTTON]: disabledRegisterButton,
  [Types.USER_SESSION_ENABLED_REGISTER_BUTTON]: enableRegisterButton,
  [Types.USER_SESSION_LOGOUT]: userSessionLogout,
  [Types.USER_SESSION_UPDATE_USER_DATA]: updateSessionUser,
  [Types.USER_SESSION_SET_CONCIERGE_PERMISSION]: setConciergePermission,
  [Types.USER_SESSION_COLLAPSE_SIDEBAR]: userSessionCollapseSidebar,
  [Types.USER_SESSION_UNCOLLAPSE_SIDEBAR]: userSessionUncollapseSidebar,
  [Types.USER_SESSION_LOCATIONS_LIST]: locationsList,
  [Types.USER_SESSION_MENU_ITEM_ACTIVE]: updateMenuItemActive,
});
